import styled from 'styled-components'

import { fontWeight } from 'uikit/styles/theme'
import { mediaBreakpointDown } from '../../../styles/media'

export const AddFileItemInner = styled.div`
  height: 0;
  padding-bottom: 95%;
  position: relative;
`

export const AddFileItemInnerContent = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  left: 10px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.alto};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.gray};
  background: ${props => props.theme.colors.white};
  .add-file-icon {
    font-size: 46px;
    margin: 15px 0 30px 0;
    ${mediaBreakpointDown('sm')`
      font-size: 36px;
      margin-bottom: 20px;
    `};
  }
  .add-file-text {
    font-size: 20px;
  }
`

export const AddFileItemWrapper = styled.li`
  width: 33.33333%;
  ${mediaBreakpointDown('sm')`
    width: 50%;
  `}
`

export const UploadListUl = styled.ul`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 10px;
  background: ${props =>
    props.isImage ? props.theme.colors.alabasterAlt : props.theme.colors.wildSand};
  &:empty {
    padding: 0;
  }
`

export const StyledAttachmentItemContent = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

export const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.colors.crimson};
`

export const ErrorContentTitle = styled.div`
  font-weight: ${props => props.theme.fontWeight.medium};
  padding: 0 15px;
  font-size: 11px;
  text-align: center;
  ${mediaBreakpointDown('xs')`
    display: none;
  `};
`

export const ImageContent = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const UploadIndicatorWrapper = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  z-index: 10;
  top: 20px;
  right: 20px;
`

export const StyledAttachmentItem = styled.div`
  overflow: hidden;
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  left: 10px;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.white};
  opacity: ${props => (props.uploaded ? '1' : '.33')};
  transition: all 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
  ${({ draggable, uploaded }) =>
    draggable &&
    `
    cursor: move;
    &:hover {
      transform: translate(0, ${uploaded ? '-5px' : 0});
    }
  `};
`

export const UploadStatusItem = styled.li`
  opacity: ${props => props.opacity};
  width: 33.33333%;
  ${mediaBreakpointDown('sm')`
        width: 50%;
      `};
`

export const UploadStatusItemInner = styled.div`
  height: 0;
  padding-bottom: 95%;
  position: relative;
`

export const RemoveButtonWrapper = styled.div`
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.colors.alto};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.theme.colors.chicago};
  &:hover {
    border: 1px solid ${props => props.theme.colors.stTropaz};
    background: ${props => props.theme.colors.stTropaz};
    color: ${props => props.theme.colors.white};
  }
  ${mediaBreakpointDown('xs')`
    width: 26px;
    height: 26px;
    font-size: 14px;
  `};
`

export const FileBarWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  ${mediaBreakpointDown('xs')`
    padding: 5px;
    font-size: 12px;
  `};
`

export const FileNameWrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-grow: 1;
  color: ${props => props.theme.colors.mineShaft};
  padding-right: 5px;
`

export const FileOrder = styled.span`
  font-weight: ${fontWeight.bold};
  margin-right: 4px;
`

export const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const MainImageLabel = styled.div`
  position: absolute;
  z-index: 15;
  width: 30px;
  height: 30px;
  background: ${props => props.theme.colors.tussock};
  color: ${props => props.theme.colors.white};
  text-transform: uppercase;
  width: 100px;
  height: 22px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-45deg);
  top: 15px;
  left: -24px;
  font-weight: ${fontWeight.light};
`
